import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-ad-orchestrate",
  "use": "icon-soc-mall-ad-orchestrate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-ad-orchestrate\">\r\n<g fill=\"currentColor\">\r\n  <rect x=\"160\" y=\"200\" width=\"280\" height=\"80\" rx=\"16\" />\r\n  <rect x=\"160\" y=\"360\" width=\"420\" height=\"80\" rx=\"16\" />\r\n  <rect x=\"160\" y=\"520\" width=\"340\" height=\"80\" rx=\"16\" />\r\n  <path d=\"M640 240l200 120-200 120V240z\" opacity=\"0.7\" />\r\n  <rect x=\"620\" y=\"560\" width=\"240\" height=\"180\" rx=\"24\" opacity=\"0.55\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-ad-orchestrate.svg
// module id = EkwF
// module chunks = 534